import {getIdToken} from "./features/auth/cognitoAuth";

export const BASE_URL = process.env.REACT_APP_AWS_USER_ENDPOINT;

// Auth header for API calls: the verified per-user Cognito Bearer token.
// Returns null when not signed in — callers shouldn't hit the data API
// unauthenticated; if they do, the request omits Authorization and the API
// rejects it (correct). No shared-token fallback (JWT-only).
export const getAuthHeader = async () => {
  try {
    const idToken = await getIdToken();
    if (idToken) return `Bearer ${idToken}`;
  } catch {
    /* not signed in / Cognito not configured */
  }
  return null;
};

export const COUNTRIES = [
  {
    code: "US",
    flag: "https://flagcdn.com/us.svg",
    dialCode: "+1",
    countryName: "United States",
  },
  {
    code: "CA",
    flag: "https://flagcdn.com/ca.svg",
    dialCode: "+1",
    countryName: "Canada",
  },
  {
    code: "BR",
    flag: "https://flagcdn.com/br.svg",
    dialCode: "+55",
    countryName: "Brazil",
  },
  {
    code: "PL",
    flag: "https://flagcdn.com/pl.svg",
    dialCode: "+48",
    countryName: "Poland",
  },
  {
    code: "IN",
    flag: "https://flagcdn.com/in.svg",
    dialCode: "+91",
    countryName: "India",
  },
];

export const categories = [
  {name: "All", icon: "🧩"},
  {name: "Healthy Lifestyle", icon: "🥬"},
  {name: "Career Exploration", icon: "🔍"},
  {name: "Essential Skills", icon: "🛠️"},
  {name: "Financial Literacy", icon: "💰"},
  {name: "Job Applications and Interviewing", icon: "💼"},
];
